import { useMemo, useState } from "react";

import { Stack } from "@similarweb/ui-components/foundations";

import { swSettings } from "app/common/services/swSettings";
import {
    getAllPremiumFeatures,
    getBasePremiumFeatures,
    getMostPopularPremiumFeatures,
    getNtMostPopularPremiumFeatures,
    PREMIUM_FEATURES_FILTERS,
} from "app/pages/sales-intelligence/pages/premium-features/configs";
import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { PremiumFeatureFilter } from "../../components/PremiumFeatureFilter/PremiumFeatureFilter";
import { PremiumFeatureHeader } from "../../components/PremiumFeatureHeader/PremiumFeatureHeader";
import { AllFeaturesContainer } from "../AllFeaturesContainer/AllFeaturesContainer";
import { MostPopularContainer } from "../MostPopularContainer/MostPopularContainer";

import { StyledContentWrapper, StyledPremiumFeatureFilterContainer } from "./styles";

export const PremiumFeaturesContainer = () => {
    const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
    const isNTUser = isNoTouch(swSettings);

    const mostPopularFeatures = useMemo(() => {
        const premiumMostFeature = isNTUser ? getNtMostPopularPremiumFeatures() : getMostPopularPremiumFeatures();
        if (selectedFilters.length === 0) {
            return premiumMostFeature;
        }

        return premiumMostFeature.filter((feature) => selectedFilters.some((filter) => feature.tags.includes(filter)));
    }, [selectedFilters, isNTUser]);

    const allFeatures = useMemo(() => {
        const premiumFeature = isNTUser ? getBasePremiumFeatures() : getAllPremiumFeatures();
        if (selectedFilters.length === 0) {
            return premiumFeature;
        }

        return premiumFeature.filter((feature) => selectedFilters.some((filter) => feature.tags.includes(filter)));
    }, [selectedFilters, isNTUser]);

    return (
        <Stack gap="40px">
            <PremiumFeatureHeader />
            <StyledContentWrapper>
                <StyledPremiumFeatureFilterContainer>
                    <PremiumFeatureFilter
                        allFilters={PREMIUM_FEATURES_FILTERS}
                        selectedFilters={selectedFilters}
                        setFilters={setSelectedFilters}
                    />
                </StyledPremiumFeatureFilterContainer>

                {mostPopularFeatures.length > 0 ? <MostPopularContainer features={mostPopularFeatures} /> : null}
                {allFeatures.length > 0 ? <AllFeaturesContainer features={allFeatures} /> : null}
            </StyledContentWrapper>
        </Stack>
    );
};
